import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vShow as _vShow, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container-full-app bg-grey-50" }
const _hoisted_2 = { class: "s20" }
const _hoisted_3 = { class: "widget shadow-100 s20 pb-2" }
const _hoisted_4 = { class: "container-full-2 s20 my-5" }
const _hoisted_5 = { class: "s13 flex justify-content-right" }
const _hoisted_6 = { class: "form-field-floating default sm s8_mobile ml-3" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "form-field-floating default sm s4_mobile ml-3" }
const _hoisted_9 = { class: "custom-filter-set-area" }
const _hoisted_10 = { class: "grid-filter6 mt-4 mb-0" }
const _hoisted_11 = { class: "form-field-floating reactive sm" }
const _hoisted_12 = { class: "form-field-floating reactive sm" }
const _hoisted_13 = { class: "form-field-floating reactive sm" }
const _hoisted_14 = {
  key: 0,
  class: "alert alert-danger mb-4"
}
const _hoisted_15 = {
  key: 1,
  class: "flex-center py-10"
}
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { class: "table separator skin3 selection rounded" }
const _hoisted_18 = {
  class: "btn-circle",
  for: "check_all"
}
const _hoisted_19 = ["checked"]
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "selection-item" }
const _hoisted_22 = ["for"]
const _hoisted_23 = ["id", "value"]
const _hoisted_24 = { class: "flex" }
const _hoisted_25 = {
  class: "square-xl rounded-15",
  style: {"background-color":"rgb(var(--color-warning-rgb), 0.2)"}
}
const _hoisted_26 = ["src"]
const _hoisted_27 = {
  class: "text-xl font-semibold",
  style: {"width":"15%"}
}
const _hoisted_28 = { class: "text-sm text-grey-600 mt-1" }
const _hoisted_29 = { class: "text-sm text-grey-600" }
const _hoisted_30 = { class: "text-3xl" }
const _hoisted_31 = { class: "mt-1 text-sm" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { class: "flex-right gap-4" }
const _hoisted_34 = ["onClick", "disabled"]
const _hoisted_35 = { style: {"display":"flex","flex-direction":"row","justify-content":"center"} }

import { computed, inject, onMounted, reactive, ref, toRaw } from 'vue';
    import ConfirmationModal from '@/components/ConfirmationModal.vue';
    import ToastNotification from '@/components/ToastNotification.vue';
    import axios from 'axios';
    import { formatDate } from '../../../utils';
    import { useRoute } from 'vue-router';
    import CustomPagination from '@/components/CustomPagination.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ProspectsListView',
  setup(__props) {

    const BACKEND_URL = inject('BACKEND_URL');
    const route = useRoute();
    const errorMessage = ref('');
    const loading = ref(false);
    const loadingInvitations = ref(false);
    const toastMessage = ref('');
    const toastType = ref<'success' | 'error' | 'info' | 'warning'>('success');
    const showToast = ref(false);
    const itemsList = ref([] as any[]);
    const confirmationModalRef = ref<InstanceType<typeof ConfirmationModal> | null>(null);
    const selectedItems = ref([] as any[]);
    const areAllItemsSelected = computed(() => {
        return itemsList.value.length == selectedItems.value.length;
    });
    const startupInfos = reactive({
        collectivites: [] as any[],
        pays: [] as any[]
    });
    const queryParams = reactive({
        pageNumber: 1,
        sortDir: 'ASC',
        sortColumn: 'fullname',
        sortOption: 'fullname_asc',
        borneInf: '',
        borneSup: '',
        pays_id: '',
        collectivite_id: '',
        search: '',
        trashed: 0
    });
    const pagination = reactive({
        total: 0,
        per_page: 10,
        last_page: 1
    });
    const SORT_OPTIONS = [
        { value: 'fullname_asc', label: 'Nom & Prénoms (ASC)', sort_column: 'fullname', sort_direction: 'ASC' },
        { value: 'fullname_desc', label: 'Nom & Prénoms (DESC)', sort_column: 'fullname', sort_direction: 'DESC' },
        { value: 'created_at_asc', label: 'Date (ASC)', sort_column: 'created_at', sort_direction: 'ASC' },
        { value: 'created_at_desc', label: 'Date (DESC)', sort_column: 'created_at', sort_direction: 'DESC' },
    ];
    const showAdvancedFilters = ref(false);

    onMounted(async () => {
        // Charger les collectivités pour le filtre
        try {
            const collectivitesResponse = await axios.get('/backoffice/collectivites/list?pageSize=1000');
            startupInfos.collectivites = collectivitesResponse.data.data || [];
        } catch (error: any) {
            console.error('Erreur lors du chargement des collectivités:', error);
        }

        // Lire collectivite_id depuis les query params
        const collectiviteIdParam = route.query.collectivite_id as string;
        if (collectiviteIdParam) {
            queryParams.collectivite_id = collectiviteIdParam;
        }
        
        doListItems();
    });

    async function doListItems() {
        try {
            loading.value = true;
            errorMessage.value = '';
            const queryParamsRaw = toRaw(queryParams);
            const queryString = new URLSearchParams(Object.fromEntries(Object.entries(queryParamsRaw).filter(([k,v]) => v !== '').map(([k,v]) => [k, String(v)]))).toString();
            const httpResponse = await axios.get(`/backoffice/prospects/list?${queryString}`);
            itemsList.value = httpResponse.data.data || [];
            pagination.total = httpResponse.data.total || 0;
            pagination.per_page = httpResponse.data.per_page || 10;
            pagination.last_page = httpResponse.data.last_page || 1;
        } catch (error: any) {
            errorMessage.value = error.message || 'Erreur lors du chargement des prospects';
            itemsList.value = [];
        } finally {
            loading.value = false;
        }
    }

    function onPaginate(pageNumber: number) {
        queryParams.pageNumber = pageNumber;
        doListItems();
    }

    function handleCheckAll(_event: any) {
        const checked = _event.target.checked;
        if (checked) {
            selectedItems.value = itemsList.value.map(i => i.id);
        } else {
            selectedItems.value = [];
        }
    }

    function toggleAdvancedFilters() {
        showAdvancedFilters.value = !showAdvancedFilters.value;
    }

    function onFiltersChanged() {
        queryParams.pageNumber = 1;
        doListItems();
    }

    function onSortChanged() {
        // Convertir sortOption en sortColumn et sortDir
        const option = queryParams.sortOption;
        if (option === 'fullname_asc') {
            queryParams.sortColumn = 'fullname';
            queryParams.sortDir = 'ASC';
        } else if (option === 'fullname_desc') {
            queryParams.sortColumn = 'fullname';
            queryParams.sortDir = 'DESC';
        } else if (option === 'created_at_asc') {
            queryParams.sortColumn = 'created_at';
            queryParams.sortDir = 'ASC';
        } else if (option === 'created_at_desc') {
            queryParams.sortColumn = 'created_at';
            queryParams.sortDir = 'DESC';
        }
        queryParams.pageNumber = 1;
        doListItems();
    }

    function getStatusTags(item: any) {
        const tags = [];
        if (item.email_verified_at) {
            tags.push({ label: 'Authentification', type: 'success' });
        } else {
            tags.push({ label: 'Authentification', type: 'warning' });
        }
        
        if (item.souscription_id) {
            tags.push({ label: 'Souscription', type: 'success' });
        } else {
            tags.push({ label: 'Souscription', type: 'warning' });
        }
        
        if (item.code_securite) {
            tags.push({ label: 'Code de sécurité', type: 'success' });
        } else {
            tags.push({ label: 'Code de sécurité', type: 'warning' });
        }
        
        if (item.actif) {
            tags.push({ label: 'Actif', type: 'success' });
        } else {
            tags.push({ label: 'Inactif', type: 'warning' });
        }
        
        return tags;
    }

    function formatDateFrench(dateString: string | null): string {
        if (!dateString) return '';
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return '';
        const monthsFr = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
        return `${date.getDate()} ${monthsFr[date.getMonth()]} ${date.getFullYear()}`;
    }

    async function sendInvitation(prospect: any) {
        try {
            loadingInvitations.value = true;
            const response = await axios.post('/backoffice/users/send_confirmation_email', {
                user_id: prospect.id
            });
            showToast.value = true;
            toastMessage.value = 'Invitation envoyée avec succès';
            toastType.value = 'success';
            doListItems();
        } catch (error: any) {
            showToast.value = true;
            toastMessage.value = error.response?.data?.message || error.message || "Erreur lors de l'envoi de l'invitation";
            toastType.value = 'error';
        } finally {
            loadingInvitations.value = false;
        }
    }

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[29] || (_cache[29] = _createElementVNode("div", { class: "page-space-30" }, null, -1)),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "s7" }, [
            _createElementVNode("h4", { class: "font-semibold mt-4" }, [
              _createTextVNode("Prospects "),
              _createElementVNode("span", { class: "text-sm text-grey-500" }, "(recent)")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("select", {
                class: "form-input-select",
                name: "collectivite",
                id: "collectivite",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryParams.collectivite_id) = $event)),
                onChange: onFiltersChanged
              }, [
                _cache[8] || (_cache[8] = _createElementVNode("option", { value: "" }, "Toutes les collectivités", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(startupInfos.collectivites, (col) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: col.id,
                    key: col.id
                  }, _toDisplayString(col.nom), 9, _hoisted_7))
                }), 128))
              ], 544), [
                [_vModelSelect, queryParams.collectivite_id]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("select", {
                class: "form-input-select",
                name: "sort",
                id: "sort",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryParams.sortOption) = $event)),
                onChange: onSortChanged
              }, [...(_cache[9] || (_cache[9] = [
                _createElementVNode("option", { value: "fullname_asc" }, "Nom & Prénoms (ASC)", -1),
                _createElementVNode("option", { value: "fullname_desc" }, "Nom & Prénoms (DESC)", -1),
                _createElementVNode("option", { value: "created_at_asc" }, "Date (ASC)", -1),
                _createElementVNode("option", { value: "created_at_desc" }, "Date (DESC)", -1)
              ]))], 544), [
                [_vModelSelect, queryParams.sortOption]
              ])
            ]),
            _createElementVNode("button", {
              onClick: toggleAdvancedFilters,
              class: "btn normal white2 s3_mobile ml-4 justify-content-center btn-filtre btn-filter"
            }, [...(_cache[10] || (_cache[10] = [
              _createElementVNode("img", {
                src: "/icons/icon-filter.svg",
                class: "btn-icon",
                alt: ""
              }, null, -1),
              _createElementVNode("span", null, "Options", -1)
            ]))])
          ]),
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "clear-both" }, null, -1)),
          _withDirectives(_createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  class: "form-input",
                  name: "date1",
                  id: "date1",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((queryParams.borneInf) = $event)),
                  onChange: onFiltersChanged,
                  placeholder: ""
                }, null, 544), [
                  [_vModelText, queryParams.borneInf]
                ]),
                _cache[11] || (_cache[11] = _createElementVNode("label", { for: "date1" }, "Date de création <=", -1))
              ]),
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  class: "form-input",
                  name: "date2",
                  id: "date2",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((queryParams.borneSup) = $event)),
                  onChange: onFiltersChanged,
                  placeholder: ""
                }, null, 544), [
                  [_vModelText, queryParams.borneSup]
                ]),
                _cache[12] || (_cache[12] = _createElementVNode("label", { for: "date2" }, "Date de création >=", -1))
              ]),
              _createElementVNode("div", _hoisted_13, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-input",
                  name: "search",
                  id: "search",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((queryParams.search) = $event)),
                  onInput: onFiltersChanged,
                  placeholder: ""
                }, null, 544), [
                  [_vModelText, queryParams.search]
                ]),
                _cache[13] || (_cache[13] = _createElementVNode("label", { for: "search" }, "Recherche", -1))
              ])
            ])
          ], 512), [
            [_vShow, showAdvancedFilters.value]
          ])
        ])
      ]),
      _createVNode(ToastNotification, {
        message: toastMessage.value,
        type: toastType.value,
        show: showToast.value,
        "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => (showToast.value = $event))
      }, null, 8, ["message", "type", "show"]),
      (errorMessage.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(errorMessage.value), 1))
        : _createCommentVNode("", true),
      (loading.value && itemsList.value.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [...(_cache[16] || (_cache[16] = [
            _createElementVNode("div", { class: "loader dark" }, null, -1)
          ]))]))
        : (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("table", _hoisted_17, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, [
                    _createElementVNode("label", _hoisted_18, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        id: "check_all",
                        checked: areAllItemsSelected.value,
                        onChange: handleCheckAll
                      }, null, 40, _hoisted_19)
                    ])
                  ]),
                  _cache[17] || (_cache[17] = _createElementVNode("th", null, null, -1)),
                  _cache[18] || (_cache[18] = _createElementVNode("th", null, [
                    _createElementVNode("img", {
                      src: "/icons/icon-filter-up.svg",
                      class: "size-xxs mt--1",
                      alt: ""
                    }),
                    _createTextVNode(" Information")
                  ], -1)),
                  _cache[19] || (_cache[19] = _createElementVNode("th", null, [
                    _createElementVNode("img", {
                      src: "/icons/icon-filter-up.svg",
                      class: "size-xxs mt--1",
                      alt: ""
                    }),
                    _createTextVNode(" Utilisation")
                  ], -1)),
                  _cache[20] || (_cache[20] = _createElementVNode("th", null, [
                    _createElementVNode("img", {
                      src: "/icons/icon-filter-up.svg",
                      class: "size-xxs mt--1",
                      alt: ""
                    }),
                    _createTextVNode(" Collectivité")
                  ], -1)),
                  _cache[21] || (_cache[21] = _createElementVNode("th", null, [
                    _createElementVNode("img", {
                      src: "/icons/icon-filter-up.svg",
                      class: "size-xxs mt--1",
                      alt: ""
                    }),
                    _createTextVNode(" Statut")
                  ], -1)),
                  _cache[22] || (_cache[22] = _createElementVNode("th", { class: "flex-right" }, null, -1))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (itemsList.value.length === 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_20, [...(_cache[23] || (_cache[23] = [
                      _createElementVNode("td", {
                        colspan: "7",
                        class: "text-center text-grey-500 py-10"
                      }, "Aucun prospect trouvé", -1)
                    ]))]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemsList.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: "text-grey-700 over-effect",
                    key: 'item_' + index
                  }, [
                    _createElementVNode("td", _hoisted_21, [
                      _createElementVNode("label", {
                        class: "btn-circle",
                        for: 'item_check_' + index
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          name: "selectedItems[]",
                          id: 'item_check_' + index,
                          value: item.id,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedItems).value = $event))
                        }, null, 8, _hoisted_23), [
                          [_vModelCheckbox, selectedItems.value]
                        ])
                      ], 8, _hoisted_22)
                    ]),
                    _createElementVNode("td", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("img", {
                          src: !!item.photo_url ? item.photo_url : '/assets/users_avatar/600w/user.jpg',
                          width: "100%"
                        }, null, 8, _hoisted_26)
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_27, [
                      _createTextVNode(_toDisplayString(item.nom) + " " + _toDisplayString(item.prenom) + " ", 1),
                      _createElementVNode("p", _hoisted_28, _toDisplayString(item.email), 1),
                      _createElementVNode("p", _hoisted_29, _toDisplayString(item.telephone), 1)
                    ]),
                    _createElementVNode("td", _hoisted_30, [
                      _createTextVNode(_toDisplayString(item.quotite_cessible_pourcent ? item.quotite_cessible_pourcent + '%' : '-') + " ", 1),
                      _createElementVNode("p", _hoisted_31, _toDisplayString(item.quotite_cessible_montant ? new Intl.NumberFormat('fr-FR').format(item.quotite_cessible_montant) + ' F' : '-'), 1)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(item.collectivite?.nom || 'N/A'), 1),
                    _createElementVNode("td", null, [
                      _cache[25] || (_cache[25] = _createElementVNode("p", { class: "text-xl font-semibold mb-2" }, [
                        _createElementVNode("span", { class: "tag-state warning stroke" }, "En attente")
                      ], -1)),
                      (item.created_at)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" Invitation envoyée le " + _toDisplayString(formatDateFrench(item.created_at)), 1),
                            _cache[24] || (_cache[24] = _createElementVNode("br", { class: "mb-5" }, null, -1))
                          ], 64))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getStatusTags(item), (tag, tagIndex) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: tagIndex }, [
                          _createElementVNode("span", {
                            class: _normalizeClass('tag-state ' + tag.type + ' stroke')
                          }, _toDisplayString(tag.label), 3),
                          (tagIndex < getStatusTags(item).length - 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_32, " "))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_33, [
                        _createVNode(_component_router_link, {
                          to: '/app/users/form/' + item.id
                        }, {
                          default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                            _createElementVNode("button", { class: "btn tips" }, [
                              _createElementVNode("img", {
                                src: "/icons/icon-edit.svg",
                                class: "btn-icon",
                                alt: ""
                              }),
                              _createElementVNode("span", null, "Editer")
                            ], -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"]),
                        _createElementVNode("button", {
                          class: "btn white2 active",
                          onClick: ($event: any) => (sendInvitation(item)),
                          disabled: loadingInvitations.value
                        }, [...(_cache[27] || (_cache[27] = [
                          _createElementVNode("img", {
                            src: "/icons/icon-send.svg",
                            class: "btn-icon",
                            alt: ""
                          }, null, -1),
                          _createElementVNode("span", null, "Inviter", -1)
                        ]))], 8, _hoisted_34)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createVNode(CustomPagination, {
                modelValue: queryParams.pageNumber,
                "onUpdate:modelValue": [
                  _cache[7] || (_cache[7] = ($event: any) => ((queryParams.pageNumber) = $event)),
                  onPaginate
                ],
                total: pagination.total,
                "per-page": pagination.per_page,
                last_page: pagination.last_page
              }, null, 8, ["modelValue", "total", "per-page", "last_page"])
            ])
          ])),
      _cache[28] || (_cache[28] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1))
    ]),
    _cache[30] || (_cache[30] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1)),
    _createVNode(ConfirmationModal, {
      ref_key: "confirmationModalRef",
      ref: confirmationModalRef
    }, null, 512)
  ]))
}
}

})